import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricTopPosShare extends MetricBase {
    constructor() {
        super({
            field: "metric_top_pos_share_ratio",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.trivago.topPosShare.chartName"),
            serieLabel: i18n.t("metrics.trivago.topPosShare.serieLabel"),
            tooltip: i18n.t("metrics.trivago.topPosShare.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricTopPosShare;
